import { StepperStep } from "@ac-expo/ui-components";

export type PurchaseTunnelStepId = "cart" | "identification" | "forms" | "payment";

export type PurchaseTunnelStep = StepperStep & { id: PurchaseTunnelStepId };

type BuildPurchaseTunnelStepsParams = {
  isLoggedIn: boolean;
  eventFormsCount: number;
  isPaid: boolean;
};

export const buildPurchaseTunnelSteps = ({
  isLoggedIn,
  eventFormsCount,
  isPaid,
}: BuildPurchaseTunnelStepsParams): PurchaseTunnelStep[] => [
  { id: "cart", label: "Panier" },
  ...(isLoggedIn ? [] : [{ id: "identification" as const, label: "Identification" }]),
  ...(eventFormsCount > 0
    ? [{ id: "forms" as const, label: eventFormsCount > 1 ? "Formulaires" : "Formulaire" }]
    : []),
  { id: "payment", label: isPaid ? "Paiement" : "Confirmation" },
];

export const isPurchaseTunnelStepId = (stepId: string): stepId is PurchaseTunnelStepId =>
  stepId === "cart" || stepId === "identification" || stepId === "forms" || stepId === "payment";
